import FieldSkeleton from '@forms/Components/FieldSkeleton';
import { Skeleton } from '@mui/material';

import styles from './Form.module.css';

interface AppointmentFormSkeletonProps {
	legend?: string;
	showLocationDetails?: boolean;
}

/**
 *  Appointment form component detailing the Scheduled time, Actual time, and Location of an appointment
 */
export default function AppointmentFormSkeleton(props: AppointmentFormSkeletonProps) {
	return (
		<div>
			<fieldset
				style={{ minWidth: '0' }}
				className={styles.fieldset}
			>
				<legend className={styles.legend}>{props.legend}</legend>

				<div className={styles.container}>
					<div className={styles['flex-row']}>
						<FieldSkeleton
							labelText='Scheduled'
							containerClassName={styles['date-input']}
						/>

						<FieldSkeleton
							labelText='From'
							containerClassName={styles['time-input']}
						/>

						<FieldSkeleton
							labelText='To'
							containerClassName={styles['time-input']}
						/>
					</div>

					<div>
						<FieldSkeleton
							labelText='Actual'
							containerClassName={styles['date-time-input']}
						/>
					</div>

					<FieldSkeleton containerClassName={styles['loc-dropdown']} />

					{props.showLocationDetails && (
						<div className={styles['location-details']}>
							<span className={styles['address-lbl']}>Address</span>
							<Skeleton
								variant='text'
								className={styles['address1']}
							/>
							<Skeleton
								variant='text'
								className={styles['address2']}
							/>

							<span className={styles['area-lbl']}>Area</span>
							<Skeleton
								variant='text'
								className={styles['area1']}
							/>
							<Skeleton
								variant='text'
								className={styles['area2']}
							/>

							<span className={styles['phone-lbl']}>Phone</span>
							<Skeleton
								variant='text'
								className={styles['phone']}
							/>

							<span className={styles['fax-lbl']}>Fax</span>
							<Skeleton
								variant='text'
								className={styles['fax']}
							/>

							<span className={styles['email-lbl']}>Email</span>
							<Skeleton
								variant='text'
								className={styles['email']}
							/>

							<span className={styles['notes-lbl']}>Notes</span>
							<Skeleton
								variant='text'
								className={styles['notes']}
							/>

							<span className={styles['pudl-notes-lbl']}>{`${props.legend ?? ''} Notes`}</span>
							<Skeleton
								variant='text'
								className={styles['pudl-notes']}
							/>
						</div>
					)}
				</div>
			</fieldset>
		</div>
	);
}
